.wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

/* ── Trigger: consistent with the Select pills ── */
.trigger {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  height: 36px;
  padding: 0 var(--space-3);
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--radius-md);
  color: var(--text-muted);
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  font-weight: var(--weight-regular);
  cursor: pointer;
  white-space: nowrap;
  transition:
    border-color var(--duration-fast) var(--ease-default),
    color var(--duration-fast) var(--ease-default);
}

.trigger:hover {
  border-color: var(--border-strong);
  color: var(--text-primary);
}

.triggerOpen {
  border-color: var(--active);
  color: var(--text-primary);
}

.count {
  padding: 0 var(--space-1);
  border-radius: var(--radius-sm);
  background: var(--bg-hover);
  color: var(--text-muted);
  font-size: var(--text-xs);
  font-weight: var(--weight-semi);
}

/* ── Menu ── */
.menu {
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: var(--space-2);
  min-width: 240px;
  max-height: 360px;
  overflow-y: auto;
  background: var(--bg-elevated);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  padding: var(--space-1);
  z-index: var(--z-dropdown);
  box-shadow: var(--shadow-lg);
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-1) var(--space-2) var(--space-2);
}

.title {
  font-size: var(--text-xs);
  font-weight: var(--weight-bold);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wide);
  color: var(--text-muted);
}

.reset {
  border: none;
  background: none;
  color: var(--accent-secondary-text);
  font-family: var(--font-sans);
  font-size: var(--text-xs);
  font-weight: var(--weight-semi);
  cursor: pointer;
}

.reset:hover {
  text-decoration: underline;
}

.reorderGroup {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* ── Row (locked + draggable share this) ── */
.row {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-sm);
  background: var(--bg-elevated);
}

.row:hover {
  background: var(--bg-hover);
}

.rowLocked {
  opacity: 0.7;
}

.toggle {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex: 1;
  min-width: 0;
  padding: var(--space-1) 0;
  border: none;
  background: none;
  color: var(--text-primary);
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  text-align: left;
  cursor: pointer;
}

.label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Checkbox box */
.box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
  color: var(--bg-base);
}

.boxOn {
  background: var(--accent-secondary);
  border-color: var(--accent-secondary);
}

.lockIcon {
  color: var(--text-muted);
  flex-shrink: 0;
  margin-right: var(--space-1);
}

.grip {
  color: var(--text-disabled);
  cursor: grab;
  flex-shrink: 0;
  margin-left: var(--space-2);
}

.grip:active {
  cursor: grabbing;
}
